module.exports = __webpack_public_path__ + "assets/01.9a15a97b.pdf";